import { render, staticRenderFns } from "./htmlPage.vue?vue&type=template&id=478cfa60&"
import script from "./htmlPage.vue?vue&type=script&lang=js&"
export * from "./htmlPage.vue?vue&type=script&lang=js&"
import style0 from "./htmlPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports